export default "__VITE_ASSET__D5ClST14__"